export default {
  componentSelector: '#google-search-controller',
  selectors: {
    searchContentContainer: '[data-comp-google-search-results]',
    formHandler: '[data-comp-google-search-form-handler]',
    sortHandler: '[data-comp-google-search-sort-handler]',
    paginationContainer: '.pagination-links--gsc-pagination',
    paginationButtons: '.pagination-links__button',
  },
};
